// Dependencies
import { RadioButton } from 'primereact/radiobutton';
import React, { Component } from 'react';

// Multi lang
import { withTranslation } from 'react-multi-lang';
// Styling
import './allowance-invoice-detail.scss';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ALLOWANCE_EXPENSE_TYPE_BUS, ALLOWANCE_EXPENSE_TYPE_HOTEL, ALLOWANCE_EXPENSE_TYPE_MEAL, ALLOWANCE_EXPENSE_TYPE_PLANE, ALLOWANCE_EXPENSE_TYPE_TAXI, ALLOWANCE_EXPENSE_TYPE_TRAIN } from '../../../../common/constants';
import DocumentService from '../../../../redux/services/document';
import { convertBase64ToArrayBuffer, downloadFile } from '../../../../common/utils/download-utils';
import AllowanceService from '../../../../redux/services/allowance';

class AllowanceInvoiceDetailComponent extends Component {
    
    amountBodyTemplate(rowData) {

        if(rowData.amount.toString().includes(".")) {
            let amountParts = rowData.amount.toString().split(".");

            if(amountParts[1].length === 1) {
                return rowData.amount + "0 €";
            }
            else {
                return rowData.amount + " €";
            }     
        }
        else {
            return rowData.amount + ".00 €";
        }
        
        return "";
    }

    invoiceLinkTemplate(invoice) {
        return <a onClick={() => this.downloadDocument(invoice.documentRef)}>{invoice.filename}</a>;
    }

    getFormattedInvoiceData() {
        let invoices = [];

        if(this.props.allowanceInvoiceData.kmsValue !== null) {
            invoices.push({
                expenseType: this.props.t("allowances.dialog.invoices.expense-type-car").replace("{0}", this.props.allowanceInvoiceData.kms),
                amount: this.props.allowanceInvoiceData.kmsValue,
                invoices: <div></div>
            });
        }

        if(this.props.allowanceInvoiceData.hotelValue !== null) {

            let filteredInvoices = this.getInvoicesFromExpenseType(ALLOWANCE_EXPENSE_TYPE_HOTEL, this.props.allowanceInvoiceData.invoiceDocuments);

            invoices.push({
                expenseType: this.props.t("allowances.dialog.invoices.expense-type-hotel").replace("{0}", this.props.allowanceInvoiceData.hotelNumberNights),
                amount: this.props.allowanceInvoiceData.hotelValue,
                invoices: <div>
                            {
                                filteredInvoices.map((invoice) => { 
                                    return <p>{this.invoiceLinkTemplate(invoice)}</p>;
                                })
                            }
                            </div>
            });
        }

        if(this.props.allowanceInvoiceData.mealValue !== null) {

            let filteredInvoices = this.getInvoicesFromExpenseType(ALLOWANCE_EXPENSE_TYPE_MEAL, this.props.allowanceInvoiceData.invoiceDocuments);

            invoices.push({
                expenseType: this.props.t("allowances.dialog.invoices.expense-type-meal").replace("{0}", this.props.allowanceInvoiceData.mealNumber),
                amount: this.props.allowanceInvoiceData.mealValue,
                invoices: <div>
                            {
                                filteredInvoices.map((invoice) => { 
                                    return <p>{this.invoiceLinkTemplate(invoice)}</p>;
                                })
                            }
                            </div>
            });
        }

        if(this.props.allowanceInvoiceData.busValue !== null) {

            let filteredInvoices = this.getInvoicesFromExpenseType(ALLOWANCE_EXPENSE_TYPE_BUS, this.props.allowanceInvoiceData.invoiceDocuments);

            invoices.push({
                expenseType: this.props.t("allowances.dialog.invoices.expense-type-bus"),
                amount: this.props.allowanceInvoiceData.busValue,
                invoices: <div>
                            {
                                filteredInvoices.map((invoice) => { 
                                    return <p>{this.invoiceLinkTemplate(invoice)}</p>;
                                })
                            }
                            </div>
            });
        }

        if(this.props.allowanceInvoiceData.trainValue !== null) {

            let filteredInvoices = this.getInvoicesFromExpenseType(ALLOWANCE_EXPENSE_TYPE_TRAIN, this.props.allowanceInvoiceData.invoiceDocuments);

            invoices.push({
                expenseType: this.props.t("allowances.dialog.invoices.expense-type-train"),
                amount: this.props.allowanceInvoiceData.trainValue,
                invoices: <div>
                            {
                                filteredInvoices.map((invoice) => { 
                                    return <p>{this.invoiceLinkTemplate(invoice)}</p>;
                                })
                            }
                            </div>
            });
        }

        if(this.props.allowanceInvoiceData.taxiValue !== null) {

            let filteredInvoices = this.getInvoicesFromExpenseType(ALLOWANCE_EXPENSE_TYPE_TAXI, this.props.allowanceInvoiceData.invoiceDocuments);

            invoices.push({
                expenseType: this.props.t("allowances.dialog.invoices.expense-type-taxi"),
                amount: this.props.allowanceInvoiceData.taxiValue,
                invoices: <div>
                            {
                                filteredInvoices.map((invoice) => { 
                                    return <p>{this.invoiceLinkTemplate(invoice)}</p>;
                                })
                            }
                            </div>
            });
        }

        if(this.props.allowanceInvoiceData.planeValue !== null) {

            let filteredInvoices = this.getInvoicesFromExpenseType(ALLOWANCE_EXPENSE_TYPE_PLANE, this.props.allowanceInvoiceData.invoiceDocuments);

            invoices.push({
                expenseType: this.props.t("allowances.dialog.invoices.expense-type-plane"),
                amount: this.props.allowanceInvoiceData.planeValue,
                invoices: <div>
                            {
                                filteredInvoices.map((invoice) => { 
                                    return <p>{this.invoiceLinkTemplate(invoice)}</p>;
                                })
                            }
                            </div>
            });
        }

        return invoices;
    }

    getInvoicesFromExpenseType(expenseType, invoices) {
        let filteredInvoices = [];

        for (let i = 0; i < invoices.length; i++) {
            if(invoices[i].expenseType === expenseType) {
                filteredInvoices.push(invoices[i]);
            }
        }

        return filteredInvoices;
    }

    downloadDocument(documentRef) {
        AllowanceService.downloadAllowanceInvoice({ allowanceRef: this.props.allowanceRef, documentRef: documentRef })
          .then((response) => {
                var blob = new Blob([convertBase64ToArrayBuffer(response.fileContent)], { type: response.contentType });
                downloadFile(URL.createObjectURL(blob), response.filename);
          })
          .catch(error => {
              this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
          });
    }

    render() {

        return (
            this.props.allowanceInvoiceData !== null ?
                <>
                    <div className="col-12 mgt-10">
                        <label><b>{this.props.t("allowances.dialog.invoices.title")}</b></label>
                    </div>
                    <div className="col-12">
                        <DataTable value={this.getFormattedInvoiceData()} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("allowances.messages.no-invoices")}>
                            <Column field="expenseType" header={this.props.t("allowances.dialog.invoices.expense-type-header")} style={{ minWidth: '50px' }}  />
                            <Column field="invoices" header={this.props.t("allowances.dialog.invoices.invoices-header")}   />
                            <Column field="amount" header={this.props.t("allowances.dialog.invoices.amount-header")} body={(data) => this.amountBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                        </DataTable>
                    </div>
                </>
            : null
        );
    }
}

export default withTranslation(AllowanceInvoiceDetailComponent);